import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const AlertDialog = ({
  open,
  handleClose,
  title,
  name,
  message,
  deleteData,
}) => {
  const { t } = useTranslation();
  const onDelete = () => {
    deleteData();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title ? title : t("common.delete")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message ? message : t("common.deleteConfirm", { name })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          style={{ color: "white" }}
          onClick={handleClose}
        >
          {t("common.no")}
        </Button>
        <Button
          variant="contained"
          color="success"
          style={{ color: "white" }}
          onClick={onDelete}
          autoFocus
        >
          {t("common.yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AlertDialog;
